import NativeAgreementCard from './NativeAgreementCard.component';

export default NativeAgreementCard;
